// Hire design tokens - Direction C · Soft Panel (ported from AIMS).
// Source of truth for the CSS-variable layer (tokens.css) and the MUI theme
// (theme.js). Same brand primary (#00519C) as AIMS - same company, one look.

export const lightTokens = {
  bg: '#eef1f5',
  surface: '#ffffff',
  'surface-2': '#f7f9fb',
  'surface-tint': '#eaf1f9',
  border: '#e3e8ef',
  'border-strong': '#d4dae3',
  text: '#18212f',
  muted: '#687385',
  faint: '#94a0b3',
  rail: '#00519C',
  'rail-active': 'rgba(255,255,255,.16)',
  'on-rail': '#ffffff',
  primary: '#00519C',
  'primary-hover': '#0a63b8',
  'primary-tint': '#eaf1f9',
  'on-primary': '#ffffff',
  pass: '#2e7d32',
  'pass-bg': '#e6f4e7',
  fail: '#c62828',
  'fail-bg': '#fbe9e9',
  warn: '#ed6c02',
  'warn-bg': '#fbe7cf',
  info: '#1565c0',
  'info-bg': '#e3effb',
  neutral: '#687385',
  'neutral-bg': '#eceff3',
};

export const darkTokens = {
  bg: '#0f1622',
  surface: '#18212f',
  'surface-2': '#141d2b',
  'surface-tint': '#16293f',
  border: '#273245',
  'border-strong': '#36425a',
  text: '#e8edf4',
  muted: '#9aa6b8',
  faint: '#6b7689',
  rail: '#0c1a2e',
  'rail-active': 'rgba(255,255,255,.10)',
  'on-rail': '#e8edf4',
  primary: '#3d8fdc',
  'primary-hover': '#5aa2e8',
  'primary-tint': '#16293f',
  'on-primary': '#0b1422',
  pass: '#5cba60',
  'pass-bg': '#16301a',
  fail: '#ef5b5b',
  'fail-bg': '#311616',
  warn: '#ffa733',
  'warn-bg': '#322008',
  info: '#5aa2e8',
  'info-bg': '#102538',
  neutral: '#9aa6b8',
  'neutral-bg': '#222d40',
};

export const radius = { xs: 8, sm: 11, md: 14, pill: 999 };

export const shadow = {
  sm: '0 1px 3px rgba(16,24,40,.08)',
  md: '0 6px 24px -6px rgba(16,24,40,.12), 0 2px 6px rgba(16,24,40,.05)',
  smDark: '0 1px 3px rgba(0,0,0,.4)',
  mdDark: '0 8px 28px -8px rgba(0,0,0,.55)',
};

export const space = { 1: 4, 2: 8, 3: 12, 4: 16, 5: 20, 6: 24, 8: 32, 10: 40 };

export const fontSans = "'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
export const fontMono = "'IBM Plex Mono', ui-monospace, Menlo, Monaco, Consolas, monospace";

export const tokensByMode = { light: lightTokens, dark: darkTokens };
